import React from 'react';
import { useHistory } from 'react-router-dom';
import EntityContentType from '@/constants/EntityContentType';

export default function useEntityDetails() {
  const history = useHistory();

  const openEntity = React.useCallback(
    ({
      constituentId,
      entityType,
      entityId,
    }: {
      constituentId?: string;
      entityType: EntityContentType;
      entityId: string;
    }) => {
      const searchParams = new URLSearchParams(history.location.search);
      if (constituentId) {
        searchParams.set('entity_constituent_id', constituentId);
      }
      searchParams.set('entity_id', entityId);
      searchParams.set('entity_type', entityType);

      history.push({
        pathname: history.location.pathname,
        search: `?${searchParams.toString()}`,
      });
    },
    [history],
  );

  const closeEntity = React.useCallback(() => {
    const searchParams = new URLSearchParams(history.location.search);
    searchParams.delete('entity_constituent_id');
    searchParams.delete('entity_id');
    searchParams.delete('entity_type');

    const searchParamsStr = searchParams.toString();

    history.push({
      pathname: history.location.pathname,
      search: searchParamsStr.length ? `?${searchParamsStr}` : undefined,
    });
  }, [history]);

  function openDonationEntity(constituentId: string, entityId: string) {
    openEntity({
      constituentId,
      entityType: EntityContentType.DONATION,
      entityId,
    });
  }

  function openAnnouncementEntity(constituentId: string, entityId: string) {
    openEntity({
      constituentId,
      entityType: EntityContentType.ANNOUNCEMENT,
      entityId,
    });
  }

  function openCampaignEntity(constituentId: string, entityId: string) {
    openEntity({
      constituentId,
      entityType: EntityContentType.CAMPAIGN,
      entityId,
    });
  }

  function openInteractionEntity(constituentId: string, entityId: string) {
    openEntity({
      constituentId,
      entityType: EntityContentType.INTERACTION,
      entityId,
    });
  }

  function openConstituentTaskEntity(constituentId: string, entityId: string) {
    openEntity({
      constituentId,
      entityType: EntityContentType.TASK,
      entityId,
    });
  }

  function openOpportunityEntity(entityId: string) {
    openEntity({
      entityType: EntityContentType.OPPORTUNITY,
      entityId,
    });
  }

  function openReceivedEmailEntity(entityId: string) {
    openEntity({
      entityType: EntityContentType.EMAIL_RECEIVED,
      entityId,
    });
  }

  function openSentEmailEntity(entityId: string) {
    openEntity({
      entityType: EntityContentType.EMAIL_SENT,
      entityId,
    });
  }

  function openTaskEntity(entityId: string) {
    openEntity({
      entityType: EntityContentType.TASK,
      entityId,
    });
  }

  return {
    closeEntity,
    openAnnouncementEntity,
    openCampaignEntity,
    openConstituentTaskEntity,
    openDonationEntity,
    openEntity,
    openInteractionEntity,
    openOpportunityEntity,
    openReceivedEmailEntity,
    openSentEmailEntity,
    openTaskEntity,
  };
}
